<template>
	<modal ref="modalCadCargo">
		<div :key="reatividade">
			<button
				type="button"
				class="close"
				@click="
					$refs.modalCadCargo.modalHide()
					$emit('recarrega-lista')
				"
			>
				<span aria-hidden="true">&times;</span>
			</button>

			<h4 class="modal-title">
				{{ _traducao('global', 'cadastro').toUpperCase() }} {{ _traducao('global', 'de').toUpperCase() }}
				{{ _traducao('global', 'cargo').toUpperCase() }}/{{ _traducao('global', 'funcao').toUpperCase() }}
			</h4>

			<hr style="margin-bottom: 0px" />

			<div class="container-fluid conteudo">
				<div class="col-sm-12">
					<div class="row">
						<div class="col-sm-12">
							<div class="text-center" v-show="load">
								<flCarregando />
							</div>
						</div>
					</div>

					<div class="row" v-show="!load" style="margin-top: 20px">
						<!-- Busca e resultado -->
						<div class="col-sm-6">
							<!-- Busca -->
							<div class="row">
								<div class="col-sm-6">
									<i class="fa fa-search icone-busca" style="top: 6px; font-size: 12pt; z-index: 10" aria-hidden="true"></i>
									<input
										type="text"
										style="padding-left: 25px"
										:placeholder="_traducao('global', 'buscar')"
										v-model="tabela.busca"
										class="form-control"
									/>
								</div>

								<div class="col-sm-6">
									<button type="button" @click="exibirNovo" class="btn btn-block pull-right btn-default">
										<i class="icon-solicitacao_nova_solicitacao" style="margin-top: 1px; margin-right: 3px; float: left"></i>
										<label style="margin-right: 3px; font-size: 10pt">
											{{ _traducao('global', 'novo').capitalizeFirst() }}
											{{ _traducao('global', 'cargo') }}/ {{ _traducao('global', 'funcao') }}</label
										>
									</button>
								</div>
							</div>

							<!-- lista -->
							<div class="row" style="margin-top: 8px; overflow: auto">
								<div class="col-sm-12">
									<table class="table table-lista table-striped table-hover" style="font-size: 9pt">
										<thead>
											<tr>
												<th style="width: 85%">{{ _traducao('global', 'descricao') }}</th>
												<th class="text-center">{{ _traducao('global', 'editar') }}</th>
												<th class="text-center">{{ _traducao('global', 'excluir') }}</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, index) in tabelaFiltrada" :key="index">
												<td>{{ item.descricao }}</td>

												<td class="text-center">
													<a href="#" @click.prevent="editar(item)" style="margin-left: 6px; margin-right: 6px">
														<i class="fa icon-editar" style="font-size: 20px"></i>
													</a>
												</td>

												<td class="text-center">
													<a href="#" @click.prevent="excluir(item)" style="margin-left: 6px; margin-right: 6px">
														<i class="fa icon-lixeira" style="font-size: 20px"></i>
													</a>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>

							<!-- paginacao -->
							<div class="row">
								<div class="col-sm-12 text-center">
									<nav>
										<ul class="pagination" :class="{'pagination-sm': !_isMobile}" style="margin: 0px">
											<li :class="{disabled: tabela.pagination.currentPage == 1}">
												<a href="#" @click.prevent="previous">
													<span aria-hidden="true">
														<i class="fa fa-angle-left" aria-hidden="true"></i>
													</span>
												</a>
											</li>
											<li
												v-for="(item, idxPg) in tabela.pagination.pageNumbers"
												:key="idxPg"
												:class="{active: item == tabela.pagination.currentPage}"
											>
												<a href="#" @click.prevent="page(item)">{{ item }}</a>
											</li>
											<li :class="{disabled: tabela.pagination.currentPage == tabela.pagination.totalPages}">
												<a href="#" @click.prevent="next">
													<span aria-hidden="true"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
												</a>
											</li>
										</ul>
									</nav>
								</div>
							</div>
						</div>
						<!-- formulário -->
						<div class="col-sm-6 col-lg-6" v-show="exibirForm">
							<div class="row">
								<div class="col-sm-6" style="color: #555; font-size: 14px">
									<h3 v-show="form.id != 0" style="margin: 0px">
										<i
											class="icon icon-solicitacao_editar_solicitacao"
											style="margin-top: 1px; float: left; margin-right: 7px"
										></i>
										{{ _traducao('global', 'editar') }}
										{{ _traducao('global', 'cargo') }}/ {{ _traducao('global', 'funcao') }}
									</h3>

									<h3 v-show="form.id == 0" style="margin: 0px">
										<i class="icon icon-solicitacao_nova_solicitacao" style="margin-top: 1px; float: left; margin-right: 7px"></i>
										{{ _traducao('global', 'novo').capitalizeFirst() }} {{ _traducao('global', 'cargo') }}/{{
											_traducao('global', 'funcao')
										}}
									</h3>
								</div>

								<div class="col-sm-6">
									<button type="button" @click="exibirForm = false" class="btn pull-right btn-sm btn-default">
										<i class="fa fa-times"></i> {{ _traducao('global', 'fechar') }}
									</button>
								</div>
							</div>

							<div class="row">
								<div class="col-sm-12">
									<hr style="margin-top: 2px; margin-bottom: 10px" />
								</div>
							</div>

							<!-- Descrição -->
							<div class="row">
								<div class="col-sm-12" :class="{'has-error': erro.descricao != ''}">
									<label><span class="no-print">* </span>{{ _traducao('global', 'descricao') }}:</label>
									<input type="text" v-model="form.descricao" class="form-control input-sm" />
									<p class="help-block col-sm-8" style="font-size: 10pt" v-show="erro.descricao != ''">{{ erro.descricao }}</p>
								</div>
							</div>

							<!-- botao salvar -->
							<div class="row">
								<div class="col-sm-12">
									<span class="label label-info pull-left no-print">
										<i class="fa fa-info-circle"></i> {{ _traducao('global', 'obrigatorio') }}
									</span>

									<button type="button" @click="clickSalva" class="btn btn-success pull-right">
										<i class="fa fa-check" aria-hidden="true"></i> {{ _traducao('global', 'salvar').toUpperCase() }}
									</button>
								</div>
							</div>
						</div>
						<!-- info -->
						<div class="col-sm-6" v-show="!exibirForm">
							<h3 class="text-center">
								<i class="fa fa-info-circle"></i> {{ _traducao('menuCadPacote', 'PacoteCliente').toUpperCase() }} <br /><br />
								{{ _traducao('global', 'ou').toUpperCase() }} <br /><br />
								{{ _traducao('menuMoficina', 'menuMtexto2').toUpperCase() }} <i class="fa icon-editar"></i>
								{{ _traducao('menuMoficina', 'menuMtexto3').toUpperCase() }}
							</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
	</modal>
</template>

<script>
export default {
	data() {
		return {
			load: false,
			exibirForm: false,
			reatividade: 0,

			tabela: {
				busca: '',
				lista: [],
				listaChunk: [],

				columns: ['descricao'],
				inverse: 'asc',
				busca: '',
				bouse: false,

				pagination: {
					currentPage: 1,
					totalPages: 0,
					totalItens: 0,
					pageNumbers: [],
					perPage: 10
				}
			},

			form: {
				id: 0,
				descricao: ''
			},

			erro: {
				descricao: ''
			}
		}
	},

	created() {
		this.carregaLista()
	},

	methods: {
		modalShow() {
			this.$refs.modalCadCargo.modalShow(68)
		},

		exibirNovo() {
			this.form.id = 0
			this.limpaForm()
		},

		limpaForm() {
			this.exibirForm = true
			this.form.descricao = ''
			this.erro.descricao = ''
			this.reatividade++
		},

		validaForm() {
			let passou = true
			let obrigatorio = this._traducao('global', 'esteCampoEObrigatorio')

			this.erro.descricao = ''

			if (this.form.descricao == '') {
				this.erro.descricao = obrigatorio
				passou = false
			}

			return passou
		},

		clickSalva() {
			if (this.validaForm()) {
				this._axios('Funcao/salvar', 'post', {
					data: this.form,
					callback: (res) => {
						if (res.status == 'sucesso') {
							window.bus.$emit('exibir-notificacao', {type: 'success', text: this._traducao('global', 'salvoComSucesso')})
							this.form.id = 0
							this.exibirForm = false
						} else {
							window.bus.$emit('exibir-notificacao', {
								type: 'danger',
								text: this._traducao('global', 'houveUmErroAoTentarSalvar')
							})
						}
					},
					finally: () => this.carregaLista()
				})
			} else {
				bus.$emit('exibir-notificacao', {type: 'danger', text: this._traducao('global', 'corrijaCamposVermelho')})
			}
		},

		carregaLista() {
			this._axios('Funcao/listar', 'get', {
				callback: (resposta) => {
					this.tabela.lista = resposta.lista
					window.bus.$emit('atualiza-lista-cargo', resposta.lista)
				}
			})
			this.limpaForm()
		},

		editar(item) {
			this.exibirForm = true
			this.form.id = item.id
			this.form.descricao = item.descricao
		},

		excluir(item) {
			const texto = `<h3>${this._traducao('global', 'desejaExcluir')}<br/> <span class='text-danger'>${
				item.descricao
			}</span></h3>`
			this._modalExcluir(
				(retorno) => {
					if (retorno.excluir) {
						window.bus.$emit('load-in', {text: 'Excluindo'})
						this._axios('Funcao/excluir/' + item.id, 'get', {
							callback: (resposta) => {
								if (resposta._status) {
									bus.$emit('load-out')
									bus.$emit('exibir-notificacao', {type: 'success', text: this._traducao('global', 'excluidoComSucesso')})
								} else {
									window.bus.$emit('load-out')
									bus.$emit('exibir-notificacao', {type: 'danger', text: resposta.mensagem})
								}
							},

							finally: () => this.carregaLista()
						})
					}
				},
				item,
				texto,
				this._traducao('global', 'excluir').toUpperCase()
			)
		}
	},

	computed: {
		//filtro para tabela por 1 campo apenas
		tabelaFiltrada() {
			if (this.tabela.busca) {
				let exp = new RegExp(this.tabela.busca.trim(), 'i')
				return this.tabela.lista.filter((x) => exp.test(x.descricao))
			} else {
				return this.tabela.lista
			}
		}
	}
}
</script>